module.exports = __webpack_public_path__ + "img/qu_ec.3f4f1c1.jpg";